import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ThreadRelatedObjectType } from '../../models/comment-models/thread-related-object-type.enum';
import { ThreadTopic } from '../../models/comment-models/thread-topic.enum';
import { PostingChannel } from '../../models/comment-models/posting-channel.enum';
import { CommentsService } from '../../services/comments.service';
import { CustomMessageService } from '../../../core/message.service';
import { ApplicationMessage } from '../../../core/models/application-message';
import { MessageType } from '../../../core/models/enum/message-type';
import { ApplicationMessageSource } from '../../../core/models/application-message-source';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'hr-thread-post-editor',
  templateUrl: './thread-post-editor.component.html',
  styleUrls: ['./thread-post-editor.component.less'],
  standalone: false,
})
export class ThreadPostEditorComponent implements OnInit {
  @Input()
  public threadId: number;
  @Input()
  public objectTypeId: ThreadRelatedObjectType;
  @Input()
  public objectId: number;
  @Input()
  public topicId: ThreadTopic;
  @Input()
  public channelId: PostingChannel;
  @Input()
  public replyToPostId: number;
  @Input()
  public display: boolean;
  @Output()
  public onUpdate: EventEmitter<boolean> = new EventEmitter<boolean>();

  public text: string;

  public ThreadTopicEnum = ThreadTopic;

  constructor(
    private commentsService: CommentsService,
    private messageService: CustomMessageService,
    private translationService: TranslateService
  ) {}

  onCancel() {
    this.text = null;
    this.onUpdate.emit(false);
  }

  onSave() {
    if (this.threadId) {
      this.commentsService
        .AddCommentToThread(
          this.threadId,
          this.channelId,
          this.text,
          this.replyToPostId
        )
        .subscribe((r) => {
          if (r.success) {
            this.showMessage(r.message, MessageType.Success);
            this.onUpdate.emit(true);
            this.onUpdate.emit(r.success);
          } else {
            this.showMessage(r.message, MessageType.Error);
          }
        });
    } else {
      this.commentsService
        .AddCommentForObject(
          this.objectTypeId,
          this.objectId,
          this.topicId,
          this.channelId,
          this.text,
          this.replyToPostId
        )
        .subscribe((r) => {
          if (r.success) {
            this.showMessage(r.message, MessageType.Success);
            this.onUpdate.emit(true);
            this.onUpdate.emit(r.success);
          } else {
            this.showMessage(r.message, MessageType.Error);
          }
        });
    }
  }

  private showMessage(message: string, type: MessageType) {
    if (message != null && message.length > 0) {
      this.messageService.pushMessage(<ApplicationMessage>{
        type: type,
        sourceId: ApplicationMessageSource.global,
        summary: '',
        detail: message,
      });
    }
  }

  ngOnInit() {}
}
